// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/newline-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../images/fold-down-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../images/newline.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.program-run-log {
	background-color: black;
	color: white;
}

.program-run-log > div:first-child {
	margin: 10px 20px;
}

.program-run-log > div + div {
	margin-top: -5px;
}

.program-run-log > div + div > button {
	background-color: #333;
	border: 0;
	width: 100%;
}

.program-run-log > div + div > button:hover {
	background-color: #2b2b2b;
	cursor: pointer;
}

.program-run-log samp {
	white-space: pre;
}

.program-run-log samp.printing-completed .wrong-output .newline::before {
	display: inline-block;
	content: "";
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-size: 1em 1em;
	vertical-align: middle;
	width: 1em;
	height: 1em;
}

.program-run-log samp.printing-completed .wrong-output {
	background-color: #da4f49;
	animation: wrong-output-highlighting 1.2s steps(1, end) 2;
}

@keyframes wrong-output-highlighting {
	0% {
		background-color: black;
	}
	50%,
	100% {
		background-color: #da4f49;
	}
}

.program-run-log samp.printing-completed .wrong-output .newline {
	animation: wrong-output-newline-highlighting 1.2s steps(1, end) 2;
}

@keyframes wrong-output-newline-highlighting {
	0% {
		opacity: 0;
	}
	50%,
	100% {
		opacity: 1;
	}
}

.program-run-log .fold-down-icon::before {
	display: inline-block;
	content: "";
	background-repeat: no-repeat;
	background-size: 1.5rem 1.5rem;
	vertical-align: middle;
	width: 1.5rem;
	height: 1.5rem;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

i.image-marked-newline,
i.image-newline {
	display: inline-block;
	content: "";
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-repeat: no-repeat;
	background-size: 1rem 1rem;
	vertical-align: middle;
	width: 1rem;
	height: 1rem;
}

.prog-report code,
pre.program-output {
	background-color: #eeeeee;
}

.prog-report code {
	border-radius: 0.25rem;
	font-size: 0.95rem;
	padding: 0.125rem 0.25rem;
}

pre.program-output {
	box-shadow: inset 0 0 1.75px #bdbdbd;
	font-size: 0.875rem;
	padding: 0.875em;
	overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/content/exercises/prog/prog.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,yDAA6D;CAC7D,4BAA4B;CAC5B,wBAAwB;CACxB,sBAAsB;CACtB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,yDAAyD;AAC1D;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;;EAEC,yBAAyB;CAC1B;AACD;;AAEA;CACC,iEAAiE;AAClE;;AAEA;CACC;EACC,UAAU;CACX;CACA;;EAEC,UAAU;CACX;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,4BAA4B;CAC5B,8BAA8B;CAC9B,sBAAsB;CACtB,aAAa;CACb,cAAc;CACd,yDAA+D;AAChE;;AAEA;;CAEC,qBAAqB;CACrB,WAAW;CACX,yDAAuD;CACvD,4BAA4B;CAC5B,0BAA0B;CAC1B,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;CACpC,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB","sourcesContent":[".program-run-log {\n\tbackground-color: black;\n\tcolor: white;\n}\n\n.program-run-log > div:first-child {\n\tmargin: 10px 20px;\n}\n\n.program-run-log > div + div {\n\tmargin-top: -5px;\n}\n\n.program-run-log > div + div > button {\n\tbackground-color: #333;\n\tborder: 0;\n\twidth: 100%;\n}\n\n.program-run-log > div + div > button:hover {\n\tbackground-color: #2b2b2b;\n\tcursor: pointer;\n}\n\n.program-run-log samp {\n\twhite-space: pre;\n}\n\n.program-run-log samp.printing-completed .wrong-output .newline::before {\n\tdisplay: inline-block;\n\tcontent: \"\";\n\tbackground-image: url(\"../../../../images/newline-white.svg\");\n\tbackground-repeat: no-repeat;\n\tbackground-size: 1em 1em;\n\tvertical-align: middle;\n\twidth: 1em;\n\theight: 1em;\n}\n\n.program-run-log samp.printing-completed .wrong-output {\n\tbackground-color: #da4f49;\n\tanimation: wrong-output-highlighting 1.2s steps(1, end) 2;\n}\n\n@keyframes wrong-output-highlighting {\n\t0% {\n\t\tbackground-color: black;\n\t}\n\t50%,\n\t100% {\n\t\tbackground-color: #da4f49;\n\t}\n}\n\n.program-run-log samp.printing-completed .wrong-output .newline {\n\tanimation: wrong-output-newline-highlighting 1.2s steps(1, end) 2;\n}\n\n@keyframes wrong-output-newline-highlighting {\n\t0% {\n\t\topacity: 0;\n\t}\n\t50%,\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n.program-run-log .fold-down-icon::before {\n\tdisplay: inline-block;\n\tcontent: \"\";\n\tbackground-repeat: no-repeat;\n\tbackground-size: 1.5rem 1.5rem;\n\tvertical-align: middle;\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tbackground-image: url(\"../../../../images/fold-down-white.svg\");\n}\n\ni.image-marked-newline,\ni.image-newline {\n\tdisplay: inline-block;\n\tcontent: \"\";\n\tbackground-image: url(\"../../../../images/newline.svg\");\n\tbackground-repeat: no-repeat;\n\tbackground-size: 1rem 1rem;\n\tvertical-align: middle;\n\twidth: 1rem;\n\theight: 1rem;\n}\n\n.prog-report code,\npre.program-output {\n\tbackground-color: #eeeeee;\n}\n\n.prog-report code {\n\tborder-radius: 0.25rem;\n\tfont-size: 0.95rem;\n\tpadding: 0.125rem 0.25rem;\n}\n\npre.program-output {\n\tbox-shadow: inset 0 0 1.75px #bdbdbd;\n\tfont-size: 0.875rem;\n\tpadding: 0.875em;\n\toverflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
